import createFetchInstance from './fetch-client'

export interface CoreResource {
  getOpenClarificationCasesCount: (token: string) => Promise<number>
}

function fetchClarificationCases(baseUrl: string, resourceUrl: string, token: string) {
  const coreInstance = createFetchInstance(baseUrl, token)
  return coreInstance(resourceUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

function buildCoreResource(baseUrl: string): CoreResource {
  return {
    getOpenClarificationCasesCount: async (token: string) => {
      const paramsObject = {
        'page': '0',
        'size': '1',
        'filter.status': 'OPEN',
      }
      const resourceUrl = `/clarification-cases?${new URLSearchParams(paramsObject).toString()}`

      const { data } = await fetchClarificationCases(baseUrl, resourceUrl, token).get().json()
      return data.value?.totalElements
    },
  }
}

export default buildCoreResource
